import React from 'react';
import Lottie from 'lottie-react';
import animaData from '../../assets/data/dnk.json';
import './MainAnima.css';

const MainAnima = () => {
  return (
    <div className="main-anima__wrapper">
      <Lottie animationData={animaData} loop={true} autoplay={true} />
    </div>
  );
};

export default MainAnima;
